import React from 'react';
import { CONTACTS } from '../../../../utils/imports';

const explainBlock1 = (
  <p data-testid="hca-enrollment-text-1">
    Our records show that you served on active duty for less than 24 continuous
    months. To qualify for VA healthcare without other special eligibility
    factors, you must have served on active duty for at least 24 months all at
    once, without a break in service.
  </p>
);

const explainBlock2 = (
  <p data-testid="hca-enrollment-text-2">
    Our records show that you don’t have a high enough Character of Discharge to
    qualify for VA healthcare.
  </p>
);

const explainBlock3 = (
  <p data-testid="hca-enrollment-text-3">
    We determined that you’re not eligible for VA healthcare because we didn’t
    have proof of your military service (like your DD214 or other separation
    papers).
  </p>
);

const explainBlock4 = (
  <p data-testid="hca-enrollment-text-4">
    Our records show that you served in the National Guard or Reserves, and
    weren’t activated to federal active duty for at least 24 continuous months.
    To qualify for VA healthcare without other special eligibility factors, you
    must have served on active duty for at least 24 months all at once, without
    a break in service.
  </p>
);

const explainBlock5 = (
  <p data-testid="hca-enrollment-text-5">
    Our records show that you’re enrolled in CHAMPVA. We couldn’t accept your
    application because the VA medical center you applied to doesn’t offer
    services to CHAMPVA recipients.
  </p>
);

const explainBlock6 = (
  <p data-testid="hca-enrollment-text-6">
    Our records show that you didn’t serve in the U.S. military or an eligible
    foreign military. To qualify for VA healthcare, you must meet this service
    requirement.
  </p>
);

const explainBlock7 = (
  <p data-testid="hca-enrollment-text-7">
    We can’t accept an application for this Veteran. If this information is
    incorrect, call our enrollment case management team at{' '}
    <va-telephone contact={CONTACTS['222_VETS']} />.
  </p>
);

const explainBlock8 = (
  <p data-testid="hca-enrollment-text-8">
    You must submit this information so we can decide if you’re eligible for VA
    healthcare.
  </p>
);

const explainBlock9 = (
  <p data-testid="hca-enrollment-text-9">
    You don’t need to do anything unless we ask you for more information.
  </p>
);

const explainBlock10 = (
  <span data-testid="hca-enrollment-text-10">
    <p>
      Our records show that we couldn’t enroll you when you applied for VA
      healthcare in the past. But eligibility can change based on changes in
      your life or income or changes in VA eligibility requirements. And as of
      March 5, 2024, we have new options to enroll Veterans.
    </p>
    <p>
      We encourage you to apply again to help us determine if we can enroll you
      now.
    </p>
  </span>
);

const explainBlock11 = (
  <p data-testid="hca-enrollment-text-11">
    We’re in the process of verifying your military service.
  </p>
);

export default {
  explainBlock1,
  explainBlock2,
  explainBlock3,
  explainBlock4,
  explainBlock5,
  explainBlock6,
  explainBlock7,
  explainBlock8,
  explainBlock9,
  explainBlock10,
  explainBlock11,
};
